module.exports = __webpack_public_path__ + "static/media/webdesign-services-img20.8f4a497b.jpg";